// import { useTheme } from "next-themes"
import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  // const { theme = "system" } = useTheme()

  return (
    <Sonner
      // theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-right"
      closeButton
      toastOptions={{
        style: {
          background: "white",
          color: "black",
          border: "1px solid #eaeaea",
          top: "2rem",
        },
        classNames: {
          title: "text-sm font-medium",
          success: "bg-white [&_svg]:text-green-500",
          error: "bg-white  [&_svg]:text-red-500",
          info: "bg-white [&_svg]:text-blue-500",
          warning: "bg-white [&_svg]:text-yellow-500",
          default: "bg-white [&_svg]:text-gray-800",
        }
      }}
      {...props}
    />
  )
}

export { Toaster }
